import { render, staticRenderFns } from "./ProductProperties.vue?vue&type=template&id=e9c78884&"
import script from "./ProductProperties.vue?vue&type=script&lang=ts&"
export * from "./ProductProperties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports